import { cloneDeep } from "lodash";
import dayjs from "dayjs";

import { ElementStatus, ElementType, FormElement, FormElementMap } from "@/@types/entities/forms";
import { Manager } from "@/@types/entities/forms/manager";
import { BodyByType } from "./baseFormElementBodies";

export class DynamicForm implements Manager {
  private form: FormElement[];

  constructor(form: FormElement[]) {
    this.form = form;
  }

  private getCurrentInputIndex(name: string): number {
    const index = this.form.findIndex((element) => element.name === name);

    return index;
  }

  private getElementUniqueName(type: ElementType) {
    const timestamp = dayjs().unix();

    return `${type}-${timestamp}`;
  }

  private getInputElementByType<T extends ElementType>(type: T): FormElement {
    const elementBody = cloneDeep(BodyByType[type]);
    elementBody.name = this.getElementUniqueName(type);

    return elementBody;
  }

  updateForm(newForm: FormElement[]): FormElement[] {
    this.form = newForm;

    return this.form;
  }

  addElement(name = "", elementType: ElementType): string {
    const index = this.getCurrentInputIndex(name);
    const inputElement = this.getInputElementByType(elementType);

    this.form.splice(index + 1, 0, inputElement);

    return inputElement.name;
  }

  editElement<T extends ElementType>(name: string, newElement: FormElementMap[T]): FormElement[] {
    const index = this.getCurrentInputIndex(name);
    this.form[index] = newElement;

    return this.form;
  }

  copyElement(inputElement: FormElement): FormElement[] {
    const index = this.getCurrentInputIndex(inputElement.name);
    const copyElement = cloneDeep(inputElement);
    copyElement.name = this.getElementUniqueName(copyElement.type);

    this.form.splice(index + 1, 0, copyElement);

    return this.form;
  }

  removeElement(name: string): FormElement[] {
    const index = this.getCurrentInputIndex(name);
    const elementBody = cloneDeep(this.form[index]);

    elementBody.status = ElementStatus.Deleted;

    this.form[index] = elementBody;
    // this.form.splice(index, 1);

    return this.form;
  }
}
